<template>
  <div class="index-stock">
    <div class="page-title">
      <PageTitle
        class="page-home-title"
        isBack="true"
        link="home"
        fontSize="25"
        icon="fa fa-cube"
        title="Recursos Humanos"
      />
    </div>
    <b-row class="m-3 row-line">
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickManagerExpenses"
      >
        <i class="fa fa-university menu-rh-icon"></i>
        <h4 class>Gerenciamento de Despesas</h4>
      </b-col>
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickManagerPonto"
      >
        <i class="fa fa-microchip menu-rh-icon"></i>
        <h4 class>Gerenciamento de Ponto</h4>
      </b-col>
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickManagerVacation"
      >
        <i class="fa fa-sun-o menu-rh-icon"></i>
        <h4 class>Gerenciamento de Férias</h4>
      </b-col>
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickManagerCourses"
      >
        <i class="fa fa-graduation-cap menu-rh-icon"></i>
        <h4 class>Gerenciamento de Cursos</h4>
      </b-col>
    </b-row>
    <b-row class="m-3 row-line">
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickDocumentoDigital"
      >
        <i class="fa fa-file menu-rh-icon"></i>
        <h4 class>Documentos para Assinatura</h4>
      </b-col>
      <!--Novo módulo cria em outro projeto, por favor verificar quais as novas formas de criar tela aqui no RH-->
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickCadastroDocumento"
      >
        <i class="fa fa-file menu-rh-icon"></i>
        <h4 class>Cadastro de Comprovante</h4>
      </b-col>
      <b-col
        v-if="accessRh"
        class="text-center menu-rh-button"
        @click="clickAtualizacaoFuncionario"
      >
        <i class="fa fa-file menu-rh-icon"></i>
        <h4 class>Atualização Funcionário</h4>
      </b-col>
      <b-col
        v-if="accessRh || accessPoint"
        class="text-center menu-rh-button"
        @click="clickPoint"
      >
        <img src="@/assets/pointIconAzul.png" class="point-icon menu-rh-icon" />
        <h4 class>Point</h4>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//components
import PageTitle from "@/components/template/PageTitle";
import { baseApiUrlRH, baseFrontendAdminRH } from "@/global";
import axios from "axios";

export default {
  name: "IndexRH",
  components: { PageTitle },
  data() {
    return {
      userContext: this.$store.state.userContext,
      responsible: null,
      accessRh: false,
      accessPoint: false,
    };
  },
  mounted() {
    this.verifyIfPersonIsRH();
    this.verifyIfPersonAccessPoint();
  },

  methods: {
    clickManagerExpenses_old() {
      this.$router.push({ name: "expenses" });
    },
    clickManagerExpenses() {
      const token = sessionStorage.getItem("token");
      window.location.replace(
        `${baseFrontendAdminRH}/rh/despesas/${token}`
      );
    },
    clickManagerPonto() {
      this.$router.push({ name: "managerponto" });
    },
    clickManagerVacation() {
      this.$router.push({ name: "managervacation" });
    },
    clickManagerCourses() {
      const token = sessionStorage.getItem("token");
      window.location.replace(
        `${baseFrontendAdminRH}/rh/manage-courses/${token}`
      );
    },
    async clickDocumentoDigital() {
      this.$router.push({ name: "documentodigital" });
    },
    async clickCadastroDocumento() {
      const token = sessionStorage.getItem("token");
      window.location.replace(
        `${baseFrontendAdminRH}/cadastro/comprovante/${token}`
      );
    },
    async clickAtualizacaoFuncionario() {
      this.$router.push({ name: "atualizacaofuncionario" });
    },
    async clickPoint() {
      const token = sessionStorage.getItem("token");
      window.location.replace(
        `${baseFrontendAdminRH}/rh/point/report/${token}`
      );
    },
    async verifyIfPersonIsRH() {
      this.accessRh = await axios
        .get(`${baseApiUrlRH}rh/verifyIfPersonIsRH/${this.userContext.userId}`)
        .then((resp) => resp.data);
    },
    verifyIfPersonAccessPoint() {
      const matriculasAccessPoint = ['000605'];
      let mat = sessionStorage.getItem("@matricula");
      if (matriculasAccessPoint.includes(mat)) {
        this.accessPoint = true;
      }
    }
  },
};
</script>

<style>
.page-title {
  margin-top: 2px;
  text-align: center;
}

.text-menu {
  color: #0d67a0;
  font-weight: bold;
  width: 140px;
}

.menu-rh-button {
  height: 120px;
  min-width: 130px;
  max-width: 450px;
  margin-right: 8px;
  margin-bottom: 6px;
  width: 80px;
  border: 1px solid;
  background: #ddeef5;
  color: #2d62a4;
  cursor: pointer;
  box-shadow: 0 9px 9px 0 rgba(0, 0, 0, 0.397), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.menu-rh-button > h4 {
  font-size: 28px;
}

.menu-rh-button:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
  transition: 1s ease;
}

.menu-rh-button > .menu-rh-icon {
  font-size: 40px;
  margin-top: 9px;
  margin-bottom: 8px;
}

.point-icon {
  width: 45px !important;
}

/* área responsiva */
@media screen and (max-width: 600px) {
  .row-line {
    display: block;
  }

  .menu-rh-button {
    width: 100%;
  }
}
</style>
